import React from 'react'
import networkEnum from '../../networkEnum'
// import BNLogo from '../../icons/blocknative-logo-dark.svg'
import avatarPlaceholder from '../../icons/avatar-placeholder.png'
import './Header.css'

const Header = props => {
  const { connectedChain, address, balance, ens, connect } = props

  return (
    <header className="user-info-container">
      {/* <div className="user-info">
        {ens?.name ? (
          <span>
            <img
              className="user-avatar"
              // This will change when we switch to Viem
              src={(ens.avatar && ens.avatar.url) ? ens.avatar.url : avatarPlaceholder}
              alt="avatar"
            ></img>
            <div
              style={{
                marginLeft: '10px'
              }}
            >
              {ens.name}
            </div>
          </span>
        ) : (
          address && <span className="user-address">Your address: {address}</span>
        )}
        {balance != null && (
          <span>Native currency balance:&nbsp;
            {Object.keys(balance).map((key, i) => (
              <div key={key}>
                {balance[key]} {key}
              </div>
            ))}
          </span>
        )}
        {connectedChain && connectedChain?.id && (
          <span>Connected network: {networkEnum?.[connectedChain.id] || 'Localhost'}</span>
        )}
      </div> */}

      {/* <div className="user-info">
        {!connectedChain && (
          <button type="button"
            className="btn btn-primary  mx-auto"
            onClick={async () => {
              const walletsConnected = await connect()
              console.log('connected wallets: ', walletsConnected)
            }}
          >
            Connect wallet
          </button>
        )}
      </div> */}
    </header>
  )
}

export default Header
